export default __webpack_public_path__ + "static/media/sunny.b78e23f8.jpg";